var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DateTime } from 'luxon';
import { HistoryItem } from 'src/ui/views/dynamics/CaseGlobalViewPage/sections/History/HistoryList/HistoryItem';
import styles from './historyList.module.scss';
import { convertToDate, E_DATE_TYPE } from 'src/shared/helpers/dateHelpers';
var HistorySectionList = function (props) {
    var day = props.day, events = props.events, applicants = props.applicants, i18n = props.i18n, dynamicsConfig = props.dynamicsConfig, host = props.host;
    var dayDate = DateTime.fromISO(day);
    var labelDate = convertToDate(E_DATE_TYPE.DATE, dayDate);
    return (_jsxs("li", __assign({ className: styles.historySectionList }, { children: [_jsx("p", { children: labelDate }), _jsx("ul", { children: events.map(function (evt, index) { return (_jsx(HistoryItem, __assign({ i18n: i18n, host: host, applicants: applicants, dynamicsConfig: dynamicsConfig }, evt), "".concat(index, "-").concat(evt.dateOfEvent.toISO()))); }) })] })));
};
export var HistoryList = function (props) {
    var i18n = props.i18n, applicants = props.applicants, history = props.history, dynamicsConfig = props.dynamicsConfig, host = props.host;
    var eventsByDay = {};
    history.forEach(function (histItem) {
        var dayStr = histItem.dateOfEvent.toISODate();
        if (!eventsByDay[dayStr]) {
            eventsByDay[dayStr] = [];
        }
        eventsByDay[dayStr].push(histItem);
    });
    var days = Object.keys(eventsByDay).sort().reverse();
    return (_jsx("ul", __assign({ className: styles.historyListWrapper }, { children: days.map(function (dayStr) {
            return (_jsx(HistorySectionList, { i18n: i18n, host: host, applicants: applicants, dynamicsConfig: dynamicsConfig, day: dayStr, events: eventsByDay[dayStr] }, dayStr));
        }) })));
};
